'use client';
import { type Brand } from '@curology/ui-components-web/brand';
import { Navigation } from '@curology/ui-components-web/react/Navigation';
import { NavigationBar } from '@curology/ui-components-web/react/Navigation/NavigationBar';
import { NavigationBrand } from '@curology/ui-components-web/react/Navigation/NavigationBrand';
import clsx from 'clsx';
import { useAtomValue } from 'jotai';
import { usePathname } from 'next/navigation';

import { ProgressBarState } from '@/atoms/progressBar/progressBarState';
import { useFlag } from '@/utils/featureFlags/client';
import { getActiveUrls } from '@/utils/urls';

import { LoggedInControls } from './LoggedInControls';
import { LoginButton } from './LoginButton';
import ProgressBar from './ProgressBar';

export const NavBar: React.FC<{
  isAuthenticated?: boolean;
  brand: Brand;
}> = ({ isAuthenticated, brand }) => {
  const progressBar = useAtomValue(ProgressBarState.progressBarAtom);
  const isRebrandLive = useFlag('agency-rebrand');
  const brandUrls = getActiveUrls(brand, isRebrandLive);

  const showProgressBar =
    progressBar && progressBar.currentSlug && progressBar.progress;

  // Unlink the logo for the Retail 1xRx flow.
  const pathName = usePathname();
  const shouldLinkToHomepage = !pathName?.includes('/retail-one-time/');

  return (
    <Navigation translate="no">
      <NavigationBar
        className={clsx(
          'cur-items-center',
          showProgressBar
            ? 'cur-grid cur-grid-cols-[minmax(auto,_1fr)_minmax(auto,_200px)_minmax(auto,_1fr)]'
            : '',
        )}
      >
        <NavigationBrand
          href={shouldLinkToHomepage ? brandUrls.site.url : ''}
          aria-label="Back to Homepage"
        />
        {showProgressBar && <ProgressBar progressBar={progressBar} />}
        <div className={clsx(showProgressBar ? 'cur-justify-self-end' : '')}>
          {isAuthenticated === true && <LoggedInControls brand={brand} />}
          {isAuthenticated === false && <LoginButton />}
        </div>
      </NavigationBar>
    </Navigation>
  );
};
